import React, { useState } from 'react';

interface CopyButtonProps {
  textToCopy: string;
  buttonText?: string;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  className?: string;
  style?: React.CSSProperties;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  buttonText = '📋 Copy',
  position = 'top-right',
  className,
  style
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Show checkmark for 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const getPositionStyle = (): React.CSSProperties => {
    const baseStyle: React.CSSProperties = {
      position: 'absolute',
      zIndex: 10
    };

    switch (position) {
      case 'top-left':
        return { ...baseStyle, top: '8px', left: '8px' };
      case 'top-right':
        return { ...baseStyle, top: '8px', right: '8px' };
      case 'bottom-left':
        return { ...baseStyle, bottom: '8px', left: '8px' };
      case 'bottom-right':
        return { ...baseStyle, bottom: '8px', right: '8px' };
      default:
        return { ...baseStyle, top: '8px', right: '8px' };
    }
  };

  const buttonStyle: React.CSSProperties = {
    border: 'none',
    background: copied ? '#d4edda' : '#e8f4f8',
    padding: '6px 10px',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '12px',
    color: copied ? '#155724' : '#0066cc',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    ...style
  };

  return (
    <div style={getPositionStyle()} className={className}>
      <button
        onClick={handleCopy}
        style={buttonStyle}
        title={copied ? 'Copied!' : 'Copy to clipboard'}
      >
        {copied ? '✅ Copied!' : buttonText}
      </button>
    </div>
  );
};

export default CopyButton;